// extracted by mini-css-extract-plugin
export var blue = "_3r-h";
export var brand = "_3r-d";
export var darkGrey = "_3r-g";
export var disabled = "_3r-6";
export var disabledSubtle = "_3r-7";
export var error = "_3r-8";
export var green = "_3r-i";
export var grey = "_3r-f";
export var icon = "_3r-0";
export var inherit = "_3r-c";
export var lightGrey = "_3r-e";
export var orange = "_3r-k";
export var pink = "_3r-m";
export var primary = "_3r-1";
export var purple = "_3r-n";
export var quaternary = "_3r-4";
export var quinary = "_3r-5";
export var red = "_3r-l";
export var secondary = "_3r-2";
export var success = "_3r-b";
export var tertiary = "_3r-3";
export var warning = "_3r-9";
export var warningSecondary = "_3r-a";
export var white = "_3r-o";
export var yellow = "_3r-j";